@if (!!model) {
  <div>
    <app-slip-component-header type="questions" [status]="model.status"></app-slip-component-header>
    <hr />
    <ion-row class="ion-justify-content-center">
      <ion-button class="ph-btn-white" (click)="buttonInfo.op.emit()">
        {{ buttonInfo.legend }}
      </ion-button>
    </ion-row>
    <!-- <pre>{{model | json}}</pre> -->
  </div>
}
